module.exports = __webpack_public_path__ + "static/media/logo-food.0ac165d5.svg";